/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.698 15.3018h1.2875L8.5641 9h-1.604l-2.4125 6.3018h1.2787l.523-1.3667h2.8345l.5141 1.3667Zm-2.9444-2.4566L7.76 10.1821l1.0107 2.6631H6.7536ZM14.5451 9H11.592v6.3018h1.2261V13.377h1.6743c.6811 0 1.226-.2198 1.6303-.6592.4043-.4395.6065-.9492.6065-1.5249 0-.5625-.2022-1.0679-.6065-1.5161-.4043-.4483-.9316-.6724-1.5864-.6724L14.5451 9Zm-.1011 3.2827h-1.6347v-2.1621h1.6919c.2944 0 .5361.1099.7295.3252.1933.2153.29.4658.29.7515 0 .2856-.1011.5361-.3032.7514-.2022.2154-.4615.3252-.7823.3252l.0088.0088Z"
      clipRule="evenodd"
    />
    <path fill="currentColor" d="M19 15.3018h-1.2524V9H19v6.3018Z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M24 12c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0s12 5.3726 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'APIDefinition'
);
